export const mapProviders = {
  GOOGLE: 'GOOGLE',
  BING: 'BING',
};

export const calculateDistanceEngines = {
  GOOGLE: 'GOOGLE',
  BING: 'BING',
  DEFAULT: 'GOOGLE',
};
